(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
  const player = document.querySelector('[data-sj-about-player]');
  if (player && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const src = player.getAttribute('src') || '';
    player.setAttribute('src', src.replace('autoplay=1', 'autoplay=0'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('[data-sj-videos]');
  if (root) {
    const player = root.querySelector('[data-sj-player]');
    const titleEl = root.querySelector('[data-sj-now-title]');
    const metaEl = root.querySelector('[data-sj-now-meta]');
    const clips = root.querySelectorAll('[data-sj-clip]');

    clips.forEach((clip) => {
      clip.addEventListener('click', () => {
        const id = clip.getAttribute('data-youtube-id');
        if (!id || !player) return;
        player.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?rel=0&autoplay=1';
        player.title = clip.getAttribute('data-title') || '';
        if (titleEl) titleEl.textContent = clip.getAttribute('data-title') || '';
        if (metaEl) metaEl.textContent = clip.getAttribute('data-meta') || '';
        clips.forEach((other) => other.setAttribute('aria-pressed', 'false'));
        clip.setAttribute('aria-pressed', 'true');
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
